import React, { Component } from 'react';
import { Container, Row, Col, Progress } from 'reactstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submitResponse, getQuestionnaireResponseByReference, loadQnaire, resetQnaireError, getQuestionnaireByName } from '../../actions/questionnaire';
import { callApiWithB2CToken } from '../../actions/callApi';
import PropTypes from 'prop-types';

import QuestionnaireNav from '../QuestionnaireNav/QuestionnaireNav';
import Questionnaire from '../Questionnaire/Questionnaire';
import Header from '../Header/Header';
import NavBar from '../../containers/Header/NavBar';
import TitlePage from '../../containers/Header/TitlePage';
import './QuestionnairePage.css';
import recommendations from '../Recommendations';
import blankResponse from '../BlankRecResponse';

import { BrowserView, TabletView } from 'react-device-detect';
import Sidebar from 'react-sidebar';

import { qnaireDTOIncoming, age, jsonDiff, convertLetterToNumber, recommendationQuestionsToUpdate, generateResponseData, parseResponse, hasKeys } from '../simpleFunctions';
import BeatLoader from 'react-spinners/BeatLoader';
import { css } from '@emotion/core';
import { questionnaireNames, tokenRequest, questionnaireResponseUrl, msalConfig } from '../../config-client';

const Msal = require('msal');

const myMSALObj = new Msal.UserAgentApplication(msalConfig);

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    background: #41AAD9;
`;

const styles = {
  padding: '115px',
  background: '#41AAD9',
  progress: {
    width: '90%',
  },
};

const Prop = {
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};

const mapStateToProps = state => ({
  currentResponse: state.form,
  patient: state.patient,
  user: state.clinician.clinician,
  // Reference for Recommendations change
  // questionnaire: state.questionnaire.currentQuestionnaire,
  questionnaire: state.questionnaire,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      submitResponse,
      resetQnaireError,
      loadQnaire,
      getQuestionnaireResponseByReference,
      getQuestionnaireByName,
    },
    dispatch,
  );

// testing branching success
// displays questionnaire nav, questions and header title of sections
class QuestionnairePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Use: check for a completed questionnaire
      complete: [],
      // Use: for the progress bar in this page
      progress: 0,
      // Use: check for if the sidebar is open on tablet mode
      sidebarOpen: false,
      // DEPRECATED: remove and test
      isOpen: false,
      // Use: if the Patient Response has already been parsed
      fetchedQnaire: false,
      // Use: if the Questionnaire Response has been fetched
      fetchedResponse: false
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  // Use: used to open and close the menu sidebar on tablet mode
  onSetSidebarOpen(open) {
    this.setState({
      sidebarOpen: open,
    });
  }

  // Set the current questionnaire name according to the page's URL (e.g. DTT/Recommendations)
  getCurrentQuestionnaireName() {
    // e.g. "/questionnaire/DTT/group/A"
    const pathName = window.location.pathname;
    const questionnaireName = pathName.split("/")[2];
    return questionnaireName;
  }

  fetchRecommendationQnaireResponse(source, qid, qname) {
    const url = questionnaireResponseUrl + `?source=${source}&qid=${qid}&qname=${qname}&patient=false`;
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'GET')
        .then((response) => {
          return response.json();
        })
      )
      .catch(error => {return null});
  }

  postRecommendationQnaireResponse(responseObject) {
    const url = questionnaireResponseUrl;;
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    const body = JSON.stringify(responseObject);
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'POST', body)
        .then((response) => {
          return response.json();
        })
      )
      .catch(error => {return null});
  }

  // Use: triggered when the save/submit button is clicked
  handleSave = async () => {
    /*
    * These are the DEFAULT parameter values.
    * Reasoning for the parameter values:
    * - this.props.questionnaire.current.resource: the questionnaire response is used to map the form object to the correct object key names, if the response doesn't exist especially
    * - true: if the response already exists in the server then this is true
    * - this.props.currentResponse.DTT.values: the form object of the response currently
    * - this.props.patient.patient: the patient response which will be changed
    * - this.props.user: the user/clincian resource to extract some important values to construct the response resource object
    * - "DTT": if this is "DTT" then the resource id mapping is skipped since the POST request won't accept a resource with an id
    */

    // Object inside state.form that can have a different name depending on what qnaire is loaded (DTT/recommendation)
    const currFormValues = Object.values(this.props.currentResponse)[0].values;
    let responseObject = generateResponseData(this.props.questionnaire.current.resource, true, currFormValues, this.props.patient.patient, this.props.user, this.getCurrentQuestionnaireName());

    if (this.props.questionnaire.response !== undefined && this.props.questionnaire.response !== null) {
      /*
      * Reasoning for the parameter values:
      * - this.props.questionnaire.response.id: if this is "DTT" then the resource id mapping is skipped since the POST request won't accept a resource with an id
      */
      //TODO: See about removing "this.props.user", because it doesn't seem to be ever populated in redux
      responseObject = generateResponseData(
        this.props.questionnaire.current.resource, true, currFormValues,
        this.props.patient.patient, this.props.user, this.getCurrentQuestionnaireName() /*This is how it would be done if FHIR was correct, but due to issues with FHIR we have to use the qnaire name as the ID - this.props.questionnaire.response.id TODO: Restore this */
      );
    }
    
    // -------------------- RECOMMENDATIONS ------------------------

    // Workflow for pre-filling Recommendations Qnaire based on DTT Response:
    if (this.getCurrentQuestionnaireName() === 'DTT') {
      const testInitializer = parseResponse(responseObject, this.props.questionnaire.current.resource, false);
      // changedQuestions functions is an array of questionIDs of questions that have been changed in this submission
      var parsedResponse = {};
      if (this.props.questionnaire.parsedResponse !== null) {
        parsedResponse = this.props.questionnaire.parsedResponse;
      }
      var changedQuestions = jsonDiff(parsedResponse, testInitializer);
      
      // if the new submission has any changes...
      if (Object.keys(changedQuestions).length !== 0 && changedQuestions !== null) {
        // Dynamically update the "parsedResponse" object in redux store
        await this.props.loadQnaire(testInitializer);

        const questionsToUpdate = recommendationQuestionsToUpdate(changedQuestions, testInitializer, recommendations);
        // If there are any Recommendation Questions with the correct answers to trigger the recommendation change...
        if (Object.keys(questionsToUpdate).length !== 0) {
          // fetch the Questionnaire Response for that patient
          var qnaireResponse = await this.fetchRecommendationQnaireResponse(this.props.patient.patient.resource.id, this.props.patient.patient.resource.id, questionnaireNames.Recommendation);
          
          // If QnaireResponse is null, generate a brand new Recommendation Questionnaire Response first
          // Using the template found in BlankRecResponse.js
          if (qnaireResponse === null || Object.keys(qnaireResponse).length === 0) {
            // Generate Response Data (and override QnaireResponse to be that object)
            qnaireResponse = blankResponse;
            // "id": "Recommendation-<PatientID>",
            qnaireResponse.id = `Recommendation-${this.props.patient.patient.resource.id}`;
            // "author": {
            //   "reference": "Practitioner/85446eb1-b000-4cc4-8cb8-293149d0f97f",
            //   "display": "DEVJacob"
            // }
            qnaireResponse.author.reference = `${this.props.user.resourceType}/${this.props.user.id}`;
            qnaireResponse.author.display = `${this.props.user.name[0].given[0]}`;
            // "source": {
            //   "reference": "Patient/e9b97f6b-48b2-4991-9e4f-36fabfdfbb14",
            //   "display": "testing"
            // }
            qnaireResponse.source.reference = `${this.props.patient.patient.resource.resourceType}/${this.props.patient.patient.resource.id}`;
            qnaireResponse.source.display = this.props.patient.patient.resource.name[0].given[0];
          }
          else {
            qnaireResponse = qnaireResponse.resource;
          }
          // else loop through the questionsToUpdate object, and begin populating
          for (var key in questionsToUpdate) {
            if (questionsToUpdate.hasOwnProperty(key)) {
              // e.g. "A"
              const section = key[0];
              // Index of Questionnaire Section
              const itemIndex = convertLetterToNumber(section);
              // Append Recommendation to relevant answer
              if (qnaireResponse.item[itemIndex].item[0].answer === undefined) {
                qnaireResponse.item[itemIndex].item[0].answer = [
                  {
                    "valueString": ""
                  }
                ];
              }
              if (questionsToUpdate[key] !== undefined) {
                qnaireResponse.item[itemIndex].item[0].answer[0].valueString += "\n" + questionsToUpdate[key];
              }
            }
          }
          // Now post the new Qnaire Response
          await this.postRecommendationQnaireResponse(qnaireResponse);
        }
      }
    }

    // --------------------------------------------------------------

    // call to the backend to submit the created response resource object
    await this.props.submitResponse(responseObject);
    // reset the response error object
    await this.props.resetQnaireError();
    // scroll to the top and go to the next page
    window.scrollTo({ top: 210, behavior: 'smooth' });
    const { complete } = this.state;
    const url = window.location.href.split('/').pop();
    let { progress } = this.state;

    // If this page has been answered before, skip without advancing bar
    if (complete[url]) {
      const questionnaireName = this.getCurrentQuestionnaireName();
      this.props.history.push(`/questionnairePage/${questionnaireName}/group/${String.fromCharCode(url.charCodeAt() + 1)}`);
      return;
    }

    // Advance progress bar since this page has not been answered previously
    progress += 4.35; 
    complete[url] = true;
    this.setState({ complete, progress });
    const questionnaireName = this.getCurrentQuestionnaireName();
    this.props.history.push(`/questionnairePage/${questionnaireName}/group/${String.fromCharCode(url.charCodeAt() + 1)}`);
  };

  // Use: return back to the previous questionnaire page
  handleBack = () => {
    window.scrollTo({ top: 210, behavior: 'smooth' });
    const url = window.location.href.split('/').pop();
    const questionnaireName = this.getCurrentQuestionnaireName();
    this.props.history.push(`/questionnairePage/${questionnaireName}/group/${String.fromCharCode(url.charCodeAt() - 1)}`);
  };


  handleNext = () => {
    // Object inside state.form that can have a different name depending on what qnaire is loaded (DTT/recommendation)
    const currFormValues = Object.values(this.props.currentResponse)[0].values;

    // Use: see explanation in handlSave
    let responseObject = generateResponseData(
      this.props.questionnaire.current.resource, true, currFormValues,
      this.props.patient.patient, this.props.user, this.getCurrentQuestionnaireName(),
    );
    if (this.props.questionnaire.response !== undefined && this.props.questionnaire.response !== null) {
      responseObject = generateResponseData(
        this.props.questionnaire.current.resource, true, currFormValues,
        this.props.patient.patient, this.props.user, this.getCurrentQuestionnaireName() /*This is how it would be done if FHIR was correct, but due to issues with FHIR we have to use the qnaire name as the ID - this.props.questionnaire.response.id TODO: Restore this */
        );
    }

    this.props.submitResponse(responseObject);
    window.scrollTo({ top: 210, behavior: 'smooth' });
    const url = window.location.href.split('/').pop();
    if (window.confirm('You haven\'t saved your progress. To do so, select the "Save" button beside the "Next" Button. Click "OK" to continue without saving')) {
      const questionnaireName = this.getCurrentQuestionnaireName();
      this.props.history.push(`/questionnairePage/${questionnaireName}/group/${String.fromCharCode(url.charCodeAt() + 1)}`);
    }
  };

  async componentDidMount() {
    // Use: check if clinician state object is null ...
    //      occurs when the user is not logged in and they try this url path
    if (this.props.user === null) {
      this.props.history.push('/');
    }

    // call to backend to get Questionnaire Resource and load into Redux Store
    // TODO: discuss if we can move this logic to backend
    if (this.getCurrentQuestionnaireName() === 'DTT') {
      await this.props.getQuestionnaireByName(questionnaireNames.Practitioner);
    }
    else if (this.getCurrentQuestionnaireName() === 'Recommendation') {
      await this.props.getQuestionnaireByName(questionnaireNames.Recommendation);
    }

    // call to backend to get Questionnaire Response and load into Redux Store
    if (this.props.questionnaire.current !== undefined && this.props.questionnaire.current.resource !== undefined && this.props.questionnaire.current !== null && this.props.questionnaire.current.resource !== null) {
      await this.props.getQuestionnaireResponseByReference(this.props.patient.patient.resource.id, this.props.questionnaire.current.resource.id, this.props.questionnaire.current.resource.name);
    }

    this.setState({
      fetchedResponse: true,
    });
  }

  render() {
    let { data } = this.props;
    if (/* hasKeys(this.props, 'questionnaire.response.id') && */
        hasKeys(this.props, 'questionnaire.current.resource.id') &&
        this.state.fetchedQnaire === false && this.state.fetchedResponse === true) {
      // Use: create the form object based on the retrieved response resource
      // Parse practitioner response
      if (this.props.questionnaire.response !== null) {
        const testInitializer = parseResponse(this.props.questionnaire.response, this.props.questionnaire.current.resource, false);
        // load into the form object in the state
        this.props.loadQnaire(testInitializer);
      }
      else {

          if (this.getCurrentQuestionnaireName() === "DTT") {
          var genInitializer = {};
          // A1 = Full Name
          genInitializer.A1 = this.props.patient.patient.resource.name[0].given[0] + " " + this.props.patient.patient.resource.name[0].family;
          // A3 = Date of Birth
          genInitializer.A3 = this.props.patient.patient.resource.birthDate;
          // A4 = Gender
          if (this.props.patient.patient.resource.gender === "male") {
            genInitializer.A4 = {
              id: "1",
              display: "Male"
            };
          }
          else if (this.props.patient.patient.resource.gender === "female") {
            genInitializer.A4 = {
              id: "2",
              display: "Female"
            };
          }
          else {
            genInitializer.A4 = {
              id: "3",
              display: "Other"
            };
          }
          genInitializer.A5 = age(this.props.patient.patient.resource.birthDate, 'YYYY-MM-DD');
          // A20 = Marital Status
          switch (this.props.patient.patient.resource.maritalStatus.coding[0].display) {
            // Unknown -> Never married or never de facto. Not realistic that we should expect this option to be selected, but it's got a default now just in case
            case "Unknown":
              genInitializer.A20 = {
                id: "1",
                display: "Never married or never de facto"
              }
              break;
            // Annulled -> Separated/divorced/previous de facto
            case "Annulled":
              genInitializer.A20 = {
                id: "3",
                display: "Separated/divorced/previous de facto"
              }
              break;
            // Divorced -> Separated/divorced/previous de facto
            case "Divorced":
              genInitializer.A20 = {
                id: "3",
                display: "Separated/divorced/previous de facto"
              }
              break;
            // Interlocutory -> Never married or never de facto
            case "Interlocutory":
              genInitializer.A20 = {
                id: "1",
                display: "Never married or never de facto"
              }
              break;
            // Legally Separated -> Separated/divorced/previous de facto
            case "Legally separated":
              genInitializer.A20 = {
                id: "3",
                display: "Separated/divorced/previous de facto"
              }
              break;
            // Married -> Currently married or de facto
            case "Married":
              genInitializer.A20 = {
                id: "2",
                display: "Currently married or de facto"
              }
              break;
            // Polygamous -> Currently married or de facto
            case "Polygamous":
              genInitializer.A20 = {
                id: "2",
                display: "Currently married or de facto"
              }
              break;
            // Never Married -> Never married or never de facto
            case "Never Married":
              genInitializer.A20 = {
                id: "1",
                display: "Never married or never de facto"
              }
              break;
            // Domestic Partner -> Currently married or de facto
            case "Domestic Partner":
              genInitializer.A20 = {
                id: "2",
                display: "Currently married or de facto"
              }
              break;
            // Unmarried -> Never married or never de facto
            case "Unmarried":
              genInitializer.A20 = {
                id: "1",
                display: "Never married or never de facto"
              }
              break;
            // Widowed -> Widowed
            case "Widowed":
              genInitializer.A20 = {
                id: "4",
                display: "Widowed"
              }
              break;
            // Should never hit here
            default:
              genInitializer.A20 = {
                id: "1",
                display: "Never married or never de facto"
              }
          }
          this.props.loadQnaire(genInitializer);
        }
        else {
          this.props.loadQnaire(null);
        }
      }
      // // Use: set to true after the above has occured so this if condition doesn't execute again
      this.setState({
        fetchedQnaire: true,
      });
    }

    // Use: if the the user and questionnaire resource exist then show the questionnaire page
    if (this.props.user !== null &&
      this.props.questionnaire.current != null &&
      this.props.questionnaire.current.statusCode === undefined) {
      // load the form object by mapping it with the response resource object
      data = this.props.questionnaire.current.resource;
      // BACKEND ERROR HANDLING
      // The "current" object will have the following format: 
      // errorCode(pin):"token_renewal_error"
      // errorMessage(pin):"Token renewal operation failed due to timeout."
      // name(pin):"ClientAuthError"
      if (data === undefined && this.props.questionnaire.current.errorCode !== null) {
        this.props.history.push('/');
        return (
          <div>
            <React.Fragment>
              <BrowserView>
                <TitlePage>
                  <h5>Your user token has expired. Please login again.</h5>
                </TitlePage>
              </BrowserView>
            </React.Fragment>
          </div>
        )
      }
      
      data = qnaireDTOIncoming(data);
      // returned html below
      return (
        <div>
          <React.Fragment>
            <BrowserView>
              <TitlePage />
              <NavBar {...this.props} />
              <Container className="QuPage" fluid>
                <Row>
                  <Col xs="auto">
                    <QuestionnaireNav complete={this.state.complete} data={data} />
                  </Col>
                  <Col xs="8">
                    <br />
                    <Progress style={styles.progress} color="progress" value={this.state.progress} />
                    <br />
                    <Header data={data} />
                    <Questionnaire
                      handleSave={() => this.handleSave()}
                      handleNext={() => this.handleNext()}
                      handleBack={() => this.handleBack()}
                      data={data}
                      initialValues={this.props.questionnaire.parsedResponse}
                    />
                  </Col>
                </Row>
              </Container>
            </BrowserView>
            {/* Tablet View */}
            <TabletView>
              <TitlePage />
              <NavBar {...this.props} />
              <Container fluid>
                <Row>
                  <Col className="qmenu-mobile" xs="10">
                    <Sidebar
                      sidebar={<QuestionnaireNav complete={this.state.complete} data={data} />}
                      open={this.state.sidebarOpen}
                      onSetOpen={this.onSetSidebarOpen}
                      styles={{ root: { height: '766px' }, sidebar: { background: 'white', position: 'fixed' } }}
                    >
                      <svg viewBox="0 0 30 30" className="menubtn-mobile" onClick={() => { this.onSetSidebarOpen(true); }}>
                        <path fill="#000000" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
                      </svg>

                    </Sidebar>
                  </Col>
                  <Col className="form-mobile" xs="10">
                    <br />
                    <Progress color="progress" value={this.state.progress} />
                    <br />
                    <Header data={data} />
                    <Questionnaire
                      handleSave={() => this.handleSave()}
                      handleNext={() => this.handleNext()}
                      handleBack={() => this.handleBack()}
                      data={data}
                      initialValues={this.props.questionnaire.parsedResponse}
                    />
                  </Col>
                </Row>
              </Container>
            </TabletView>
          </React.Fragment>
        </div>
      );
    }

    // Use: if the user or the questionnaire resource haven't been retrieved, then show a spinner to let users know the data is being retrieved
    return (
      <div>
        <React.Fragment>
          <BrowserView>
            <TitlePage />
            <NavBar {...this.props} />
            <div style={styles}>
              <BeatLoader
                css={override}
                sizeUnit="px"
                size={40}
                color="#FFFFFF"
              />
            </div>
          </BrowserView>
          {/* Tablet View */}
          <TabletView>
            <TitlePage />
            <NavBar {...this.props} />
            <div style={styles}>
              <BeatLoader
                css={override}
                sizeUnit="px"
                size={40}
                color="#FFFFFF"
              />
            </div>
          </TabletView>
        </React.Fragment>
      </div>
    );
  }
}

// Proptypes
QuestionnairePage.propTypes = Prop;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuestionnairePage);



// WEBPACK FOOTER //
// ./src/components/QuestionnairePage/QuestionnairePage.js